import { render, staticRenderFns } from "./TableByFirm.vue?vue&type=template&id=86dea0d0&"
import script from "./TableByFirm.vue?vue&type=script&lang=ts&"
export * from "./TableByFirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports